import { render, staticRenderFns } from "./GrupoEmpresaUpdate.vue?vue&type=template&id=3f12cbbe&"
import script from "./GrupoEmpresaUpdate.vue?vue&type=script&lang=js&"
export * from "./GrupoEmpresaUpdate.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports